import { OrderDetailPage } from '@/components/orders/OrderDetailPage';

export function CustomerOrdersDetailPage() {
  return <OrderDetailPage isMember={true} />;
}
